import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SmallClipControls } from '../SmallClipControls/SmallClipControls';
import { getScreenshotSignedUrl, getClipListens } from '../../services/HalogenService';
import { FormatDate } from '../../helpers/FormatDate';
import './MiniClip.css'; // Import your CSS file here

export const MiniClip = ({ clip }) => {
    const navigate = useNavigate();
    const [screenshotUrl, setScreenshotUrl] = useState(clip.imageURL);
    const [numListens, setNumListens] = useState(clip.numListens ? clip.numListens : 0);

    const handleNavigate = () => {
        navigate(`/focus/${clip.id}`, { replace: true });
    };

    useEffect(() => {
        if (!clip.imageURL) {
            getScreenshotSignedUrl(clip.id, 'small')
                .then(url => setScreenshotUrl(url.signedUrl))
                .catch(err => console.error(err));
        }
        if (clip.numListens === undefined) {
            getClipListens(clip.id)
                .then(listens => setNumListens(listens.listens))
                .catch(err => console.error(err));
        }
    }, [clip.id, clip.imageURL, clip.numListens]);

    return (
        <div
            onClick={handleNavigate}
            className="miniClipContainer">
            <div className="miniClipContentContainer">
                <div className='miniClipImagePlaceholder'>
                    <img src={screenshotUrl} alt="Visual Content" className="miniClipVisualContentImg" />
                </div>
                <h4 className="miniClipTitle">{clip.title}</h4>
                <p className="miniClipDetails">
                    {FormatDate(clip.created_at)} | {numListens} listens
                </p>
                <div
                    onClick={(e) => e.stopPropagation()}
                    className="miniClipControlsContainer">
                    <SmallClipControls clip={clip} color={'#F2EFF4'} />
                </div>
            </div>
        </div>
    );
};
